<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destination-slack']"
               [videos]="['notification-destinations']"></app-help-page>
